import { Contract } from "@/types/contract";
import { CONTRACT_PROCESSES, REQUEST_PROCESSES } from "./processesFlow";
import { SCREENS } from "./screens";
import { Product } from "@/types/enumerations";
import { isAssignedToCore } from "@/utils/contract";

export const getFlow = (contract: Contract, pathname: string) => {
  const isCancel = pathname.includes("/cancel");
  const isRequest = pathname.includes("/request");
  const isAddInformation = contract.state === "to_add_information";

  const process = isRequest ? REQUEST_PROCESSES[contract.process] : CONTRACT_PROCESSES[contract.process];
  const fallback = isRequest ? REQUEST_PROCESSES.fallback : CONTRACT_PROCESSES.fallback;

  if (isCancel) {
    return process?.CANCEL ?? fallback?.CANCEL;
  }

  if (isAddInformation) {
    return process?.ADD_INFORMATION ?? fallback?.ADD_INFORMATION;
  }

  if (isAssignedToCore(contract)) {
    return CONTRACT_PROCESSES.fallback?.ASSIGNED_TO_CORE_SIGNED;
  }

  if (contract.selfService) {
    return process?.SELF_SERVICE ?? fallback?.SELF_SERVICE;
  }

  return process?.NO_SELF_SERVICE ?? fallback?.NO_SELF_SERVICE;
};

export const getSubResourcePath = (pathname: string) => {
  // Sort routes by length (longest first) to match more specific routes before generic ones
  // This prevents "/signature-on-phone" from matching "/signature" first
  return Object.values(SCREENS)
    .sort((a, b) => b.length - a.length)
    .find(route => pathname.includes(route));
};

export const getNextUrl = (
  contract: Contract,
  pathname: string,
  options?: { gdprAgreed?: boolean; products?: Product[]; isRequest?: boolean }
) => {
  const flow = getFlow(contract, pathname);
  const subResourcePath = getSubResourcePath(pathname);

  if (!flow || !subResourcePath) {
    return null;
  }

  const next = flow[subResourcePath]?.next(contract, options);
  if (!next) {
    return null;
  }

  return next;
};

export const getBackUrl = (contract: Contract, pathname: string, options?: { products?: Product[]; isRequest?: boolean }) => {
  const flow = getFlow(contract, pathname);
  const subResourcePath = getSubResourcePath(pathname);

  if (!flow || !subResourcePath) {
    return null;
  }

  const back = flow[subResourcePath]?.back(contract, options);
  if (!back) {
    return null;
  }

  return back;
};

export const getContractUrl = (id: string, subResourcePath: string, isRequest: boolean) => {
  return isRequest ? `/request/${id}${subResourcePath}` : `/contract/${id}${subResourcePath}`;
};
